"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

/* eslint-disable */
var _default = /*#__PURE__*/React.createElement("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 31 31",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    display: 'inline-block',
    width: '1em',
    height: '1em',
    verticalAlign: 'middle',
    userSelect: 'none'
  }
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0, 1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.6521 3.36956H2.69574C1.95165 3.36956 1.34775 2.76565 1.34775 2.02182C1.34775 1.27773 1.95165 0.673826 2.69574 0.673826H29.6521C30.3962 0.673826 31.0001 1.27773 31.0001 2.02182C31.0001 2.76565 30.3962 3.36956 29.6521 3.36956Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.6521 10.1088H16.1739C15.4298 10.1088 14.8262 9.50487 14.8262 8.76078C14.8262 8.01695 15.4298 7.41304 16.1739 7.41304H29.6521C30.3962 7.41304 31.0001 8.01695 31.0001 8.76078C31.0001 9.50487 30.3962 10.1088 29.6521 10.1088Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.6521 16.8477H16.1739C15.4298 16.8477 14.8262 16.2441 14.8262 15.5C14.8262 14.7559 15.4298 14.1523 16.1739 14.1523H29.6521C30.3962 14.1523 31.0001 14.7559 31.0001 15.5C31.0001 16.2441 30.3962 16.8477 29.6521 16.8477Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.6521 23.587H16.1739C15.4298 23.587 14.8262 22.9831 14.8262 22.2392C14.8262 21.4951 15.4298 20.8912 16.1739 20.8912H29.6521C30.3962 20.8912 31.0001 21.4951 31.0001 22.2392C31.0001 22.9831 30.3962 23.587 29.6521 23.587Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.6521 30.3262H2.69574C1.95165 30.3262 1.34775 29.7223 1.34775 28.9782C1.34775 28.2343 1.95165 27.6304 2.69574 27.6304H29.6521C30.3962 27.6304 31.0001 28.2343 31.0001 28.9782C31.0001 29.7223 30.3962 30.3262 29.6521 30.3262Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.8084 14.7586L7.0909 10.3783C6.79573 10.1046 6.36705 10.0345 5.99784 10.1922C5.62987 10.3526 5.39122 10.7166 5.39122 11.1196V14.1523H1.34774C0.602425 14.1523 0 14.7559 0 15.5C0 16.2441 0.602425 16.8477 1.34774 16.8477H5.39122V19.8804C5.39122 20.2821 5.62987 20.6459 5.99784 20.8078C6.12864 20.8631 6.26463 20.8912 6.40209 20.8912C6.65284 20.8912 6.89963 20.7984 7.0909 20.6217L11.8084 16.2414C12.0132 16.0486 12.1304 15.7804 12.1304 15.5C12.1304 15.2196 12.0132 14.9501 11.8084 14.7586Z",
  fill: "black"
})));

exports["default"] = _default;
//# sourceMappingURL=indentLeft.js.map